export interface Module {
  num: string
  title: string
  lines: string[]
  list?: string[]
  close?: string
}

export const modules: Module[] = [
  {
    num: '1',
    title: 'Prenatal Client Assessment & Coaching Framework™',
    lines: [
      'Start every coaching relationship with a clear professional structure.',
      'Access ready-to-use intake resources, training history tools, goals and preferences profiles, readiness checks, coaching observations, communication frameworks, session feedback systems, modification records and progress reviews.',
    ],
    close: 'Know your client before building the plan.',
  },
  {
    num: '2',
    title: 'Prenatal Exercise Library™',
    lines: [
      'Stop searching for exercises every time you build a session.',
      'Access an organized professional library covering:',
    ],
    list: [
      'lower-body strength,',
      'upper-body strength,',
      'push and pull patterns,',
      'squat and hinge patterns,',
      'mobility,',
      'stability,',
      'posture,',
      'core-support,',
      'low-impact conditioning,',
      'warm-ups,',
      'and cooldowns.',
    ],
    close:
      'Each section includes coaching cues, regressions, progressions, substitutions and modification options. Find the movement you need when you need it.',
  },
  {
    num: '3',
    title: 'Trimester Adaptation System™',
    lines: [
      'Your client’s needs can change throughout pregnancy.',
      'Learn how to intelligently adapt:',
    ],
    list: [
      'exercise selection,',
      'positioning,',
      'volume,',
      'intensity,',
      'rest,',
      'session duration,',
      'equipment,',
      'and movement options.',
    ],
    close:
      'Use adaptation matrices, decision frameworks and practical scenarios to make changes based on the individual client. Stop guessing what to change next.',
  },
  {
    num: '4',
    title: 'Ready-to-Coach Session Library™',
    lines: ['This is where planning becomes faster.', 'Access complete session structures for:'],
    list: [
      'full-body strength,',
      'upper and lower body,',
      'strength + mobility,',
      'posture,',
      'low-impact conditioning,',
      'home training,',
      'gym training,',
      'minimal equipment,',
      'and lower-energy days.',
    ],
    close:
      'Warm-up. Main blocks. Exercises. Coaching cues. Modifications. Cooldown. Open. Adapt. Coach.',
  },
  {
    num: '5',
    title: 'Prenatal Program Builder™',
    lines: ['Turn individual sessions into structured programs.', 'Learn how to organize:'],
    list: [
      'weekly frequency,',
      'exercise selection,',
      'training balance,',
      'volume,',
      'progression,',
      'regression,',
      'recovery,',
      'session rotation,',
      'and changing client needs.',
    ],
    close:
      'Use complete weekly frameworks and multi-week programming examples. Never face a blank programming page again.',
  },
  {
    num: '6',
    title: 'Coaching Toolkit & Client Management™',
    lines: ['Bring your entire coaching process together.', 'Access:'],
    list: [
      'client profiles,',
      'weekly planners,',
      'session records,',
      'exercise trackers,',
      'modification logs,',
      'feedback tools,',
      'progress reviews,',
      'communication records,',
      'attendance trackers,',
      'and coaching dashboards.',
    ],
    close: 'Assess. Plan. Coach. Record. Review. Adapt.',
  },
]
